module.exports = __webpack_public_path__ + "img/editProducts-active.c43236bf.svg";